<template>
  <div class="navigation-container">
    <portal  target-el="#filter">
      <PrimaryFilter
        :noSearchFilter="true"
        :noLanguageFilter="false"
        />
    </portal>
    <h1>{{$t('NO_PAGE_PERMISSION')}}</h1>
  </div>
</template>
<script>
import PrimaryFilter from '@/components/common/PrimaryFilter';

export default {
  name: 'MenuNavigator',
  components: {
    PrimaryFilter,
  },
};
</script>
<style scoped>
  .navigation-container{
    text-align: center;

  }
  h1{
    padding-top: 40px;
  }
</style>
